<app-ace-select
  #aceselect
  [items]="processedSites"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder ?? ('Select a Site' | messageTranslate)"
  [loading]="loading"
  [multiSelect]="multiSelect"
  [groupBy]="forceShowGroup ? NG_SELECT_SITE_GROUP_BY : groupBy"
  [searchFn]="searchFn"
  [appendTo]="appendTo"
  [maxSelectedLabels]="maxSelectedLabels"
  [maxSelectedShowItemName]="maxSelectedShowItemName"
  [maxSelectedItemName]="maxSelectedItemName"
  [showClearItem]="showClearItem"
  [truncateLabels]="truncateLabels"
  [closeOnSelect]="closeOnSelect"
  [clearable]="clearable"
  [groupValue]="groupValue"
  [compareWith]="compareWith"
  [isReadOnly]="readOnly"
  (addEvent)="onAdd($event)"
  (removeEvent)="onRemove($event)"
  (clear)="onClear()"
  (openEvent)="onOpen()"
  (closeEvent)="onClose()"/>
